import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { confirmUser } from '../../actions/auths';
import { fetchUser } from '../../actions/user';

const Confirmation = ({
  confirmUser,
  fetchUser,
  history,
  location = {},
}) => {
  useEffect(() => {
    const url = location.pathname;
    const token = url.substring(url.lastIndexOf('/') + 1);
    confirmUser({ confirmation_token: token }, () => {
      fetchUser(() => {
        history.push('/dashboard');
      });
    });
  }, []);

  return <div />;
};

Confirmation.propTypes = {
  confirmUser: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
};

export default connect(null, { confirmUser, fetchUser })(Confirmation);
